export interface IMenu {
  containerClassnames: string;
  subHiddenBreakpoint: number;
  menuHiddenBreakpoint: number;
  menuClickCount: number;
  selectedMenuHasSubItems: boolean;
}

class MenuClass implements IMenu {
  containerClassnames: string = '';
  subHiddenBreakpoint: number = 0;
  menuHiddenBreakpoint: number = 0;
  menuClickCount: number = 0;
  selectedMenuHasSubItems: boolean = false;

  constructor(
    containerClassnames: string,
    subHiddenBreakpoint: number,
    menuHiddenBreakpoint: number,
    menuClickCount: number,
    selectedMenuHasSubItems: boolean,
  ) {
    this.containerClassnames = containerClassnames;
    this.subHiddenBreakpoint = subHiddenBreakpoint;
    this.menuHiddenBreakpoint = menuHiddenBreakpoint;
    this.menuClickCount = menuClickCount;
    this.selectedMenuHasSubItems = selectedMenuHasSubItems;
  }
}

export default MenuClass;
